import React, { Component } from 'react'
import Footer from './Footer.jsx'
import Enter from './Enter'

import './home/css/bootstrap.css'
import './home/css/fontawesome-all.css'
import './home/css/styles.css'
import "bootstrap/dist/css/bootstrap.min.css"

import Popup from 'reactjs-popup';

// import logo from './home/images/logo.png'

class VenueInfo extends Component {
  render() {
    return (
      <div>
        <header id="headerBlack" className="ex-header">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <h1>Seatstir's Venue Partnerships</h1>
              </div>
            </div>
          </div>
        </header>
        {/* <div>
          <Popup trigger={<button> Trigger</button>} position="right center">
            <Enter />
          </Popup>
        </div> */}
        <div>
          <br />
          <h2> Infographic will display here on what incentives Venues have to partner with Seatstir</h2>
          <br />
        </div>
        <Footer />
      </div>
    )
  }
}

export default VenueInfo